<template>
  <div class="modal-wrapper">
    <div class="modal-body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CloseChatModal'
}
</script>

<style scoped lang="sass">
.modal-wrapper
  background-color: rgba(#1B1B1D, 0.56)
  position: absolute
  display: flex
  align-items: center
  justify-content: center
  padding: 24px
  left: 0
  right: 0
  height: 100%
  z-index: 1

.modal-body
  width: 100%
  background-color: #fff
  border: 1px solid #DCDCDC
  border-radius: 5px
  font-size: 14px
  font-weight: 500
  min-height: unset
  padding: 0px

  p
    margin: 0

</style>
